import { useSyncExternalStore } from "react";

let dashboardSearchValue = "";
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => dashboardSearchValue;

export const setDashboardSearchValue = (value: string) => {
  if (dashboardSearchValue === value) {
    return;
  }

  dashboardSearchValue = value;
  listeners.forEach((listener) => listener());
};

export const resetDashboardSearchValue = () => {
  setDashboardSearchValue("");
};

export const useDashboardSearchValue = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
